<template>
  <div class="team-intr">
    <OrgMapLog></OrgMapLog>
  </div>
</template>

<script>
import OrgMapLog from './orgMapLog'
export default {
  components:{
    OrgMapLog
  },
  data(){
    return{
    }
  }
}
</script>